module.exports = __webpack_public_path__ + "static/media/pack.5746b9fb.svg";